import { Swiper, Navigation, Pagination } from 'swiper';
import RechargeInit from './recharge-init';

class ProductRecommendationsClass {
  constructor() {
    Swiper.use([Navigation, Pagination]);

    this.init();

    // For shopify customizer/editor
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId === 'product-recommendations') {
        this.init();
      }
    });
  }

  init() {
    const productRecommendationsSection = document.querySelectorAll(
      '.product-section-recommendations__inner',
    );
    productRecommendationsSection.forEach((section) => {
      let productId = section.dataset.productId;
      let sectionId = section.dataset.sectionId;
      let limit = section.dataset.limit;
      let min = section.dataset.minrecommendations;
      let intent = section.dataset.intent;

      fetch(
        window.Shopify.routes.root +
          'recommendations/products?product_id=' +
          productId +
          '&limit=' +
          limit +
          '&section_id=' + 
          sectionId + 
          '&intent=' + 
          intent,
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          
          setTimeout(() => {
            if (html.querySelectorAll('.swiper-recommendations .swiper-slide').length >= min) {
              const recommendations = html.querySelector('.swiper-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                const recommendedPlaceholders = section.querySelector('.swiper-recommendations');
                recommendedPlaceholders.innerHTML = recommendations.innerHTML;
                this.initSwiper();
              }
            } else {
              this.initSwiper();
            }
            RechargeInit();
          })
        });
    });
  }

  initSwiper() {
    Swiper.use(Navigation, Pagination);
    const recommendedProductCarousel = document
      .querySelectorAll('.product-section-recommendations .swiper')
      .forEach((carousel) => {
        const nextEl = carousel.querySelector('.swiper-button-next');
        const prevEl = carousel.querySelector('.swiper-button-prev');
        const swiper = new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl,
            prevEl,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            }
          },
        });
      });
    const recommendedProductCarouselInline = document
      .querySelectorAll('.block-related-products .swiper')
      .forEach((carousel) => {
        const nextEl = carousel.querySelector('.swiper-button-next');
        const prevEl = carousel.querySelector('.swiper-button-prev');
        const swiper = new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl,
            prevEl,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        });
      });
  }
}

export default function ProductRecommendations() {
  const productRecommendations = new ProductRecommendationsClass();
}
